import { Routes } from '@angular/router';
import { roleGuard } from './core/guards';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'proprietaire',
    canActivate: [roleGuard('PROPRIETAIRE')],
    loadComponent: () => import('./pages/proprietaire/proprietaire.component').then(m => m.ProprietaireComponent)
  },
  {
    path: 'mecanicien',
    canActivate: [roleGuard('MECANICIEN')],
    loadComponent: () => import('./pages/mecanicien/mecanicien.component').then(m => m.MecanicienComponent)
  },
  {
    path: 'garage',
    canActivate: [roleGuard('GARAGE')],
    loadComponent: () => import('./pages/garage/garage.component').then(m => m.GarageComponent)
  },
  {
    path: 'marketplace',
    loadComponent: () => import('./pages/marketplace/marketplace.component').then(m => m.MarketplaceComponent)
  },
  {
    path: 'admin',
    canActivate: [roleGuard('ADMIN')],
    loadComponent: () => import('./pages/admin/admin.component').then(m => m.AdminComponent)
  },
  { path: '**', redirectTo: '/login' }
];
